import { Button } from '../ui/button';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Check, Trash2 } from 'lucide-react';
import { displayDate } from '../../lib/dates';

export const AdvanceTable = ({ advances, fmt, onMarkDeducted, onDelete }) => (
  <Card className="hidden md:block bg-white border border-[#D1D1CD] rounded-lg shadow-sm overflow-hidden">
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow className="bg-[#F4F4F0]">
            <TableHead className="font-semibold text-[#1C1C1E]">Worker</TableHead>
            <TableHead className="font-semibold text-[#1C1C1E]">Amount</TableHead>
            <TableHead className="font-semibold text-[#1C1C1E]">Date</TableHead>
            <TableHead className="font-semibold text-[#1C1C1E] hidden md:table-cell">Reason</TableHead>
            <TableHead className="font-semibold text-[#1C1C1E]">Status</TableHead>
            <TableHead className="font-semibold text-[#1C1C1E] text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {advances.length === 0 ? (
            <TableRow>
              <TableCell colSpan={6} className="text-center py-8 text-[#5C5C5C]">
                No advance payments found
              </TableCell>
            </TableRow>
          ) : (
            advances.map((advance) => (
              <TableRow key={advance.id} data-testid={`advance-row-${advance.id}`}>
                <TableCell className="font-medium text-[#1C1C1E]">
                  {advance.worker_name}
                </TableCell>
                <TableCell>
                  <span className="font-semibold text-[#D97706]">
                    {fmt(advance.amount)}
                  </span>
                </TableCell>
                <TableCell className="text-[#5C5C5C] text-sm">
                  {displayDate(advance.date || advance.created_at)}
                </TableCell>
                <TableCell className="hidden md:table-cell text-[#5C5C5C] text-sm">
                  {advance.reason || '-'}
                </TableCell>
                <TableCell>
                  <Badge className={advance.is_deducted
                    ? 'bg-[#2E4632]/10 text-[#2E4632] border border-[#2E4632]/20'
                    : 'bg-[#D97706]/10 text-[#D97706] border border-[#D97706]/20'
                  }>
                    {advance.is_deducted ? 'Deducted' : 'Pending'}
                  </Badge>
                </TableCell>
                <TableCell className="text-right">
                  <div className="flex items-center justify-end gap-2">
                    {!advance.is_deducted && (
                      <Button
                        variant="ghost"
                        size="icon"
                        data-testid={`mark-deducted-${advance.id}`}
                        onClick={() => onMarkDeducted(advance.id)}
                        className="h-10 w-10 text-[#2E4632] hover:bg-[#2E4632]/10"
                        title="Mark as deducted"
                      >
                        <Check className="w-4 h-4" />
                      </Button>
                    )}
                    <Button
                      variant="ghost"
                      size="icon"
                      data-testid={`delete-advance-${advance.id}`}
                      onClick={() => onDelete(advance.id)}
                      className="h-10 w-10 text-[#5C5C5C] hover:text-[#BC4749] hover:bg-[#BC4749]/10"
                    >
                      <Trash2 className="w-4 h-4" />
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  </Card>
);
